import styled from 'styled-components';

import {
  BaseButton,
  buttonColors,
  ButtonColorTypes,
  ButtonProps,
  ButtonSizes,
  ButtonShape,
} from './BaseButton.sc';

const SecondaryButton= styled(BaseButton)<ButtonProps>`
  border: 1px solid ${({ $buttonColor }) => $buttonColor && buttonColors[$buttonColor]};
  color: ${({ $buttonColor }) => $buttonColor && buttonColors[$buttonColor]};
  position: relative;
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: ${({ $buttonColor }) => $buttonColor && buttonColors[$buttonColor]};
    border-radius: ${({ $buttonShape }) => ($buttonShape === ButtonShape.Rectangle ? '5px' : '50px')};
    opacity: 0;
    transition: opacity 0.5s ease-out;
  }
  &:hover:not(:disabled) {
    &::before {
      opacity: 0.15;
    }
  }
`;

SecondaryButton.defaultProps = {
  $buttonColor: ButtonColorTypes.Blue,
  $buttonSize: ButtonSizes.Medium,
};

export default SecondaryButton;
